//import { StaticContentConst, StaticContentTitle } from '.'
import css from 'styled-jsx/css'
import { iconPath } from '@ui/helpers'
import { FC, HTMLAttributes, useMemo } from 'react'
import { usePaygates } from '@ui/hooks'
//import { shopHelpPath } from '@/helpers'
import getLogRocket from '@ui/analytics/logRocket'

interface ISupportInfo extends HTMLAttributes<HTMLDivElement> {
  type?: 'desktop' | 'mobile'
}

export const SupportInfo: FC<ISupportInfo> = ({ className }) => {
  const paygates = usePaygates()
  const phone = useMemo(
    () => paygates?.paypalex?.contact?.phone || paygates?.creditcard?.contact?.phone || '',
    [paygates]
  )
  //const shopHelpPhone = '+1 (877) 778-8353'
  const { logRocket } = getLogRocket()

  function callAndTrackLogRocket() {
    logRocket?.track('SelectSupportNumber')
    window.open(`tel:${(phone && phone.replace(/\D/g, '')) || ''}`)
  }

  return (
    <>
      <style jsx>{compStyle}</style>
      <div className={`ml-40 support-footer ${className ?? ''}`}>
        <div className="">
          <p className="support-footer__head_title ">Support number</p>
          <div className="support-footer__content">
            <div className="support-footer__item">
              <figure className="icon--inline image">
                <img src={iconPath('shophelp_phone.svg')} alt="" />
              </figure>
              <a target="_self" className="is-link" onClick={callAndTrackLogRocket}>
                {phone}
              </a>
            </div>
            <div className="support-footer__item">
              <figure className="icon--inline image">
                <img src={iconPath('shophelp_clock.svg')} alt="" />
              </figure>
              <p>
                <strong>Mon-Sun: </strong> 8am-9pm <strong> EST </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const compStyle = css`
  a {
    color: var(--text);
  }

  .support-footer {
    padding-top: 16px;
    padding-bottom: 16px;

    &__content {
      margin: auto;
      justify-content: center;
    }

    &__head_title {
      font-size: 16px;
      line-height: 32px;
      font-weight: 600;
      padding-bottom: 10px;
      display: flex;
      justify-content: center;
    }

    &__item {
      display: flex;
      font-size: 13px;
      padding-top: 5px;
      padding-bottom: 5px;
      padding-left: 45%;
    }
  }

  @media screen and (min-width: 769px) {
    .support-footer {
      &__head_title {
        justify-content: center;
      }

      &__item {
        display: flex;
        font-size: 13px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 40%;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .support-footer {
      &__head_title {
        justify-content: center;
      }

      &__item {
        display: flex;
        font-size: 13px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 25%;
      }
    }
  }

  .icon {
    &--inline {
      min-width: 18px;
      margin-right: 12px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .ml-40 {
    margin-left: 40%;
  }
`
